// extracted by mini-css-extract-plugin
export default {"themeProvider":"c3_yF1IEAg_services-landings","tokens":"KOgmQkW6us_services-landings"};